import { Button, CircularProgress, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { constants } from "../Helpers/constantsFile";
import axios from "axios";
import SmsSuccess from "../containers/SMSContainers/SmsSuccess";
import Loading from "../containers/SMSContainers/Loaidng";
import moment from "moment";

const Billing = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const activeUser = useSelector((state) => state.activeUser.activeUser);
  const customers = useSelector((state) => state.users.users);
  const [showSuccess, setShowSuccess] = useState(false)
  const [successData, setSuccessData] = useState()
  const [loading, setLoading] = useState(false)
  const token = useSelector(state => state.token.token)

  let loopCustomers = []
  customers?.map(customer => {
    if (customer?.notify == "loop" && customer?.status == "active" ) loopCustomers.push(customer)
  })

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const handleSelectCustomer = (customerId) => {
    const updatedSelectedCustomers = [...selectedCustomers];
    const index = updatedSelectedCustomers.indexOf(customerId);

    if (index > -1) {
      updatedSelectedCustomers.splice(index, 1);
    } else {
      updatedSelectedCustomers.push(customerId);
    }

    setSelectedCustomers(updatedSelectedCustomers);
  };

  const handleSelectAllCustomers = () => {
    const allCustomerIds = loopCustomers.map((customer) => customer._id);
    setSelectedCustomers(
      selectedCustomers.length === allCustomerIds.length ? [] : allCustomerIds
    );
  };

  const loopAndUpload = async (element) => {

    axios.patch(
        `${constants.baseUrl}/users/${element._id}`,
        {notify: "stuck"},
        {
            headers: {
                "authorization": token
            }
        }
    ).then(res => {
       console.log(res.data?.data)
    }).catch(err => {
        console.log(err)
    });
}

  const handleSendSMS = async() => {
    // setLoading(true)
    const customersToSendSMS = customers.filter((customer) =>
      selectedCustomers.includes(customer._id)
    );

    const updatedCustomers = customersToSendSMS.map((customer) => ({
      ...customer,
      customerType: 'deynle',
      balance: 1
    }));

    for (const customer of updatedCustomers) {
        await loopAndUpload(customer);
    }
    alert("Succesfully Billed Users")

  };

  const handleLoop = () => {
     axios.get(
        `${constants.baseUrl}/admin/notify-users-monthly-bills`,
       
        {
            headers: {
                "authorization": token
            }
        }
    ).then(res => {
       console.log(res)
    }).catch(err => {
        console.log(err)
    });
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "92%",
        margin: "20px auto",
      }}
    >
    {loading && <Loading /> }

      {showSuccess && <SmsSuccess successData = {successData} hideModal = {()=> {
        setShowSuccess(false)
      }}/>}

      <Button
         
          onClick={handleLoop}
          style={{
            width: "130px",
            marginLeft: "auto",
            fontSize: "16px",
            backgroundColor: "#03656F",
            fontWeight: "600",
            color: "white",
            height: "40px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Loop
        </Button>

      <div
        style={{
          background: "white",
          padding: "20px",
          width: "100%",
          borderRadius: "10px 10px 0px 0px",
          alignItems: "center",
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "row",
          gap: "50px",
        }}
      >
        <input
          type="text"
          placeholder="Search customers"
          value={searchTerm}
          onChange={handleSearch}
          style={{
            width: "400px",
            height: "45px",
            padding: "10px",
            fontSize: "16px",
            borderRadius: "8px",
            background: "#EFF0F6",
            border: "none",
          }}
        />

        <label>
          <input
            type="checkbox"
            onChange={handleSelectAllCustomers}
            checked={selectedCustomers.length === customers.length}
            id="smsCheck"
            style={{
              transform: "scale(1.5)",
              cursor: "pointer",
              marginRight: "15px",
            }}
          />
          Select All{" "}
          {selectedCustomers.length > 0 && `(${selectedCustomers.length})`}
        </label>

        <Button
         
          onClick={handleSendSMS}
          style={{
            width: "130px",
            marginLeft: "auto",
            fontSize: "16px",
            backgroundColor: "#03656F",
            fontWeight: "600",
            color: "white",
            height: "40px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Dallac
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        {loopCustomers
          .filter(
            (customer) => 
              customer.name.toLowerCase().includes(searchTerm) ||
              customer.phone.toLowerCase().includes(searchTerm)
          )
          .map((customer) => (
            <div
              key={customer._id}
              style={{
                backgroundColor: selectedCustomers.includes(customer?._id)
                  ? "#CDEBEE"
                  : null,
                border: "1px solid grey",
                display: "flex",
                cursor: "pointer",
                flexDirection: "row",
                gap: "30px",
                padding: "15px 25px",
                borderRadius: "10px",
              }}
              onClick={() => handleSelectCustomer(customer._id)}
            >
              <input
                type="checkbox"
                checked={selectedCustomers.includes(customer._id)}
                onChange={() => handleSelectCustomer(customer._id)}
                id="smsCheck"
                style={{ transform: "scale(1.5)", cursor: "pointer" }}
              />
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {customer.name}
              </Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {customer.username}
              </Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {customer.phone}
              </Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {moment(customer.created_at).format("YYYY-MM-DD")}
              </Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {customer.notify}
              </Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>
                {customer.status}
              </Typography>
             
            </div>
          ))}
      </div>
    </div>
  );
};

export default Billing;

